import {
  scoring_repository,
} from '@/repositories';

const actions = {
  async getScores(__, input) {
    const {
      score_list,
    } = await scoring_repository.getScores(input);

    return score_list;
  },
};

export default {
  actions,
  namespaced: true,
};
